export const forbiddenWords = ["kamagra", "kamagru", "jebanje"];



// WEBPACK FOOTER //
// ./src/utils/ForbiddenWords.ts